import React from 'react'
import cx from 'classnames'

import { Icon, CheckCircleIcon, CircleIcon } from 'components/shared/Icon/Icon'
import { Tooltip } from 'components/shared/Tooltip/Tooltip'

import styles from './Step.module.scss'

export const Step = ({ className, title, onClick, isIncomplete = false }) => {
  const icon = isIncomplete ? CircleIcon : CheckCircleIcon

  return (
    <Tooltip hasArrow>
      <Tooltip.Anchor {...{ className, onClick }}>
        <Icon
          className={cx(styles.icon, { [styles.incomplete]: isIncomplete })}
          size={14}
          {...{ icon }}
        />
      </Tooltip.Anchor>
      <Tooltip.Note note={title} />
    </Tooltip>
  )
}
